<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer1">
      <b-row>
        <b-col>
          <b>
            <label>Please check which plan you want to enroll in</label>
          </b>
          <br />
          <span class="add-info">
            <b>
              All lines marked with an asterisk (
              <font color="red">*</font>&nbsp;) are required.
            </b>
          </span>
        </b-col>
        <hr />
      </b-row>
      <b-row>
        <b-col class="col-12 col-sm-6 text-sm-left text-md-right inner-box-right pt-3">
          <label class="custom-req font-weight-bold">Year&nbsp;</label>
        </b-col>
        <b-col class="p-md-3">
          <b-form-select
            id="input-1"
            v-model="form.year"
            :options="getYears()"
            v-if="years.length > 1"
            class="col-6 col-md-4 col-sm-4"
            sm="4"
            ref="year"
            @change="getPayers()"
          ></b-form-select>
          <P v-if="years.length === 1">{{form.year}}</P>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 col-sm-6 text-sm-left text-md-right inner-box-right pt-3 pt-sm-3">
          <label class="custom-req font-weight-bold">Payers and Plans</label>
        </b-col>
        <b-col class="p-md-3 p-sm-1" v-if="form.year">
          <div v-for="payer in payersList" :key="payer.LookupID">
            <h6 class="mb-0">{{payer.LookupName}}</h6>
            <hr class="mb-0" />
            <b-form-group>
              <div v-for="plan in payer.plans" :key="plan.LookupID">
                <b-form-radio
                  v-model="form.planid"
                  name="plan"
                  :value="plan.LookupID"
                  @change="setPayernPlan(payer.LookupName, plan.LookupName,payer.LookupID)"
                >
                  {{plan.LookupName}}
                </b-form-radio>
              </div>
            </b-form-group>
          </div>
          <validation-provider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes, errors }"
                  name="Plan"
                  class="col-3 p-0 mr-1"
                  vid="payerplan"
          >
            <div class="control" :class="classes">
              <input type="text" v-show="false" v-model="form.planid" ref="payerplan" />
              <span>{{ errors[0]?"Please select a Plan to proceed.":""}}</span>
            </div>
          </validation-provider>
        </b-col>

      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import MedicareLeadsService from "../../MedicareLeadsService";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";

export default {
  name: "ChoosePlan",
  components: {
    ValidationProvider
  },
  data() {
    return {
      lookups: [],
      years: [],
      payersList: [],
      error: ""
    };
  },
  props: {
    form: Object,
    payerList: Array
  },
  async created() {
    try {
      this.lookups = await MedicareLeadsService.getMedicareLookUps();
      this.years = await MedicareLeadsService.getYears();
      if (this.years.length == 1) {
        this.form.year = this.years[0].LookupYear;
      } else if (this.years.length > 1) {
        this.form.year = this.years[this.years.length - 1].LookupYear;
      }
      this.getPayers();
    } catch (err) {
      this.error = err.message;
    }
  },
  methods: {
    getYears: function() {
      var yrs = {};
      this.years.forEach(element => {
        yrs[element.LookupYear] = element.LookupYear;
      });
      return yrs;
    },
    getPayers: function() {
      this.payersList = [];
      this.lookups.forEach(element => {
      var payer = {};
        if (
          element.LookupCategory === "PAYER" &&
          element.LookupYear == this.form.year
        ) {
          payer["LookupID"] = element.LookupID;
          payer["LookupName"] = element.LookupName;
        var plansList = [];
          this.lookups.forEach(element1 => {
            var plans = {};
            if (
              element1.LookupParentID == payer.LookupID &&
              element1.LookupYear == this.form.year &&
              element1.LookupCategory === "PLAN"
            ) {
              plans["LookupID"] = element1.LookupID;
              plans["LookupName"] = element1.LookupName;
              plansList.push(plans);
            }
          });
          payer["plans"] = plansList;
          this.payersList.push(payer);
        }
      });
    },
    getPlans: function(payerid) {
      if (payerid) {
        var plansList = [];
        this.lookups.forEach(element => {
          var plans = {};
          if (
            element.LookupParentID == payerid &&
            element.LookupYear == this.form.year
          ) {
            plans["LookupID"] = element.LookupID;
            plans["LookupName"] = element.LookupName;
            plansList.push(plans);
          }
        });
        return plansList;
      } else {
        return [];
      }
    },
    onPayerSelect: function() {
      alert(this.payerid);
    },
    async setPayernPlan (payerName, planName, payerID) {
      this.form.PayerPlan = payerName + " " + planName;
      this.form.PayerID = payerID;
      this.form.PayerName = payerName;
      this.form.PlanName = planName;
      let payerData = {};
      await this.payerList.forEach(function (each) {
        if(each.PayerID==payerID){
          payerData = each;
        }
      })
      this.form.PayerPhoneNumber = payerData.PhoneNumber;
      this.form.PayerPhoneNumberExtension = payerData.PhoneNumberExtension;
      this.form.PayerHoursOfOperation = payerData.HoursOfOperation;
      this.form.PayerPaymentText = payerData.PayerPaymentText;
      this.form.PayerPrivacyPolicy = payerData.PayerPrivacyPolicy;
      this.form.PayerImpText = payerData.PayerImpText;
      this.form.URLAddress = payerData.URLAddress;
    }
  }
};
</script>
